module.exports = __webpack_public_path__ + "static/img/hoods.fba4b62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hoods.png
// module id = gZ4T
// module chunks = 64